import { MatSpinner } from '@angular/material/progress-spinner';
import { ChangeDetectionStrategy, Component, inject, model, signal, ViewChild } from '@angular/core';
import { TitleComponent } from "../../../shared/components/title-component/title-component";
import { SearchBarComponent } from '../../../shared/components/search-bar-component/search-bar-component';
import { MatCardModule } from '@angular/material/card';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatAnchor, MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { UpperCasePipe } from '@angular/common';
import { Assure } from '../../../shared/model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { AssureService } from '../../service/assure-service';
import { ToastrService } from '../../../shared/services/toastr-service';
import { Router } from '@angular/router';
import { SweetAlertService } from '../../../shared/services/sweet-alert-service';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { from } from 'rxjs';

export interface ModalDataI{
  title : string
  update ?: boolean
  data ?: Assure
}

@Component({
  selector: 'app-assure-component',
  imports: [
    TitleComponent,
    SearchBarComponent,
    MatCardModule,
    MatPaginator,
    MatPaginatorModule,
    MatSort,
    MatSortModule,
    MatTableModule,
    MatAnchor,
    MatIconModule,
    MatTooltip,
    MatButtonModule,
    UpperCasePipe,
    MatSpinner
  ],
  templateUrl: './assure-component.html',
  styleUrl: './assure-component.css',
})
export class AssureComponent {
  displayedColumns: string[] = [/*'id',*/ 'personne', 'name', 'gender','adresse', 'actions'];
  dataSource!: MatTableDataSource<Assure>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  searchValue = signal<string>('')
  currentAssure = signal<Assure>(new Assure())
  readonly dialog = inject(MatDialog);
  collaborateur_liste = signal<Assure[]>([])
  loading = false

  constructor(
    private assureService : AssureService,
    private toastr : ToastrService,
    private router : Router,
    private sweetAlert : SweetAlertService
  ){
    // Assign the data to the data source for the table to render
    this.dataSource = new MatTableDataSource<Assure>([]);
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  openAddAssureModal(){
    const data : ModalDataI = {
      title : 'Ajouter un Assure',
      data : new Assure()
    }

    const dialogRef = this.dialog.open(AssureComponentModal, {
      width : '700px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : Assure) => {

      if (result?.id != undefined) {
        this.toastr.success("L'assure "+ result.firstname +" "+ result.lastname + " à été ajouté")
        this.goToDetails(result)
      }
    });
  }

  openUpdateAssure(assure : Assure){
    let name = ''
    if(assure.firstname!=null || assure.lastname!=null)
      name = assure?.firstname+" "+assure?.lastname!
    else
      name = assure.societe

    const data : ModalDataI = {
      title : "Modifier l'assure " + name,
      update : true,
      data : assure
    }

    const dialogRef = this.dialog.open(AssureComponentModal, {
      width : '700px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : Assure) => {

      if (result?.id != undefined) {
        const i = this.dataSource.data.findIndex(item => item.id == result.id)
        const data = this.dataSource.data
        data[i] = result
        this.dataSource.data = data
        this.toastr.success("L'assure "+ name + " à été modifie")
      }
    });
  }


  confirm(assure : Assure){
    let name = ''
    if(assure.firstname!=null || assure.lastname!=null)
      name = assure?.firstname+" "+assure?.lastname!
    else
      name = assure.societe

    this.sweetAlert
    .confirm("Etez-vous sur de vouloir supprimer l'assure "+ name)
    .then((res) =>{
      if(res.isConfirmed){
        this.assureService.delete(assure.id).subscribe({
          next : (res) =>{
            this.dataSource.data = this.dataSource.data.filter(item => item.id != assure.id)
            this.sweetAlert.success('Suppression reussie', 2000)
          },
          error : (err) =>{
            this.toastr.error(err?.error.message)
          }
        })
      }
    })
  }


  applyFilter(event : string){
    this.loading = true
    this.searchValue.update(val => event)
    if(event!=''){
      this.assureService.find(event).subscribe({
        next : (res) =>{
          this.dataSource.data = res
          this.loading = false
        },
        error : (err) =>{
          this.loading = false
        }
      })
    }else{
      this.loading = false
    }

    this.dataSource.filter = event.trim().toLocaleLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  goToDetails(assure : Assure){
    //console.log('hello');
    this.router.navigateByUrl('/assure/'+assure.id)
  }
}

@Component({
  selector: 'app-assure-modal',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatSpinner,
    MatIcon
  ],
  templateUrl: './modal-assure.html',
  styleUrl: './modal-assure.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssureComponentModal {
  readonly dialogRef = inject(MatDialogRef<AssureComponentModal>);

  // recupere les donnees envoyes par le parent
  readonly inputData = inject<ModalDataI>(MAT_DIALOG_DATA);

  // retourne le donne vers le parent
  readonly assure = model(this.inputData.data!);

  assureForm : FormGroup = new FormGroup({})

  collaborateur_liste = signal<Assure[]>([])

  readonly dialog = inject(MatDialog);

  loadingbtn = signal<boolean>(false)

  constructor(
    private fb : FormBuilder,
    private assureService : AssureService,
    private toastr : ToastrService
  ){

  }

  ngOnInit(): void {
    this.assureForm = this.fb.group({
      personne : ['', [Validators.required]],
      firstname : [''],
      lastname : '',
      gender : [''],
      niu : [''],
      tel : [''],
      email : ['', [Validators.email]],
      adresse : [''],
      profession : [''],
      nif : [''],
      societe : [''],
      rc : [''],
      representant : [''],
      forme_juridique : ['']
    })
  }

  ngAfterViewInit(): void {
    this.assureForm.patchValue(this.inputData?.data!)
    this.applyValidator('physique')
  }

  resetForm(){
    this.assureForm.patchValue({
      firstname : '',
      lastname : '',
      gender : '',
      niu : '',
      tel : '',
      email : '',
      adresse : '',
      profession : '',
      nif : '',
      societe : '',
      rc : '',
      representant : '',
      forme_juridique : ''
    })
    this.assureForm.markAsUntouched()
  }


  onAdd(){
    const data = this.assureForm.value
    this.loadingbtn.update(val => true)

    this.assureService.create(data).subscribe({
      next : (res) =>{
        this.loadingbtn.update(val => false)
        this.dialogRef.close(res)
      },
      error : (err) =>{
        this.loadingbtn.update(val => false)
         this.toastr.error("Une erreur est survenue ")
      },
    })
  }

  onUpdate(){

    const data = this.assureForm.value;
    this.loadingbtn.update(val => true)

    this.assureService.update(data, this.inputData.data?.id!).subscribe({
      next : (res) =>{
        this.dialogRef.close(res)
        this.loadingbtn.update(val => false)
      },
      error : (err) =>{
         this.toastr.error("Une erreur est survenue ")
         this.loadingbtn.update(val => false)
      },
    })
  }

  onChange(event : MatSelectChange){
    this.resetForm()
    this.assureForm.clearValidators()
    this.assureForm.setErrors(null)

    this.applyValidator(event.value)
  }

  applyValidator(val : string){
    const physique : string[] = ['firstname', 'gender']
    const morale : string[] = ['societe', 'representant','forme_juridique']

    if(val == 'physique'){
      from(morale).forEach((element) => this.assureForm.get(element)?.setErrors(null));
      from(physique).forEach((element) => this.assureForm.get(element)?.addValidators(Validators.required));
    }else{
      from(physique).forEach((element) => this.assureForm.get(element)?.setErrors(null));
      from(morale).forEach((element) => this.assureForm.get(element)?.addValidators(Validators.required));
    }
  }

}


